import React from "react";
import LoveMessages from "@/components/LoveMessages";

export default function MessagesPage() {
  return <LoveMessages />;
}
